
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/poole-showroom",
      function () {
        return require("private-next-pages/poole-showroom.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/poole-showroom"])
      });
    }
  